import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import TextBox from 'components/common/text_box'
import styles from './edit_description.less'
import { DESCRIPTION_LENGTH, DESCRIPTION_ROWS } from 'shared/lengths'
import EditForm from '../edit_form'

const i18n = getI18n('components/edit_glimpse/edit_description')

class EditDescription extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    fields: PropTypes.object.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
  }

  render() {
    const {
      fields: { description },
      anyInactiveFieldsTouchedWithError,
    } = this.props

    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <div styleName="subtitle" role="heading" aria-level="2">
          {i18n('subtitle')}
        </div>
        <TextBox
          data-pa-focus="description"
          {...description}
          multiline={true}
          rows={DESCRIPTION_ROWS}
          title={i18n('description')}
          maxLength={DESCRIPTION_LENGTH}
          autoFocus={true}
        />
        <button
          data-pa-click="save"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditDescription, styles)
